import { setLoaderStart, setLoaderComplete } from "../loader/loader";

export const getAllThread = () => {
    return async (dispatch, getState, { client }) => {
        try {
            await dispatch(setLoaderStart('inbox'));
            await dispatch(setLoaderComplete('inbox'));
        } catch (error) {
            console.log("Error", error)
        }
    };
}